import { render, staticRenderFns } from "./PointStatusComponent.vue?vue&type=template&id=3c2e0f30&scoped=true"
import script from "./PointStatusComponent.vue?vue&type=script&lang=js"
export * from "./PointStatusComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2e0f30",
  null
  
)

export default component.exports